import React from 'react';
import { mockData } from '../data/mock';
import { ServiceCard } from './services/ServiceCard';
import { ServicesCTA } from './services/ServicesCTA';

const Services = () => (
  <section className="py-24 bg-gradient-to-br from-gray-50 to-cyan-50/30" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="inline-block px-4 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium mb-4">
          Our Services
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Comprehensive Financial Solutions
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          From loans to real estate and legal advisory, we provide end-to-end support for all your financial needs
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-12">
        {mockData.services.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>

      <ServicesCTA />
    </div>
  </section>
);

export default Services;
